function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { getAction } from "@/api/manage";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import { mixinDevice } from "@/utils/mixin.js";
import PhotoCard from "@/components/common/PhotoCard";
import "@/assets/less/animation.css";
export default {
  mixins: [mixinDevice],
  components: {
    JDictSelectTag: JDictSelectTag,
    PhotoCard: PhotoCard
  },
  data: function data() {
    return {
      dataSource: [],
      pagination: {
        onChange: function onChange(page) {
          console.log(page);
        },
        pageSize: this._isMobile() ? 8 : 12
      },
      productType: "",
      tenantConfig: {},
      videoVisible: false,
      currentItem: {},
      queryParam: _defineProperty({
        pageSize: 999,
        eventId: '',
        orderBy: 'star'
      }, "orderBy", 'time')
    };
  },
  created: function created() {
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    this.getList();
  },
  mounted: function mounted() {},
  methods: {
    eventChange: function eventChange(v) {
      this.queryParam.eventId = v.target.value;
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      getAction("/teaching/teachingWork/leaderboard", this.queryParam).then(function (res) {
        if (res.success) {
          _this.dataSource = res.result.records;
        }
      });
    },
    toDetail: function toDetail(id) {
      // this.$router.push('/event/workDetail?id='+id)
      var route = this.$router.resolve({
        path: "/event/workDetail",
        query: {
          id: id
        }
      });
      window.open(route.href, '_blank');
    }
  }
};